import * as moment from 'moment';

export class DurationFormatter {
    public static formatDuration(duration: moment.Duration): string;
    public static formatDuration(duration: moment.Duration, format: string): string;
    public static formatDuration(duration: moment.Duration, format?: string): string {
        if (!format) {
            format = 'mm:ss.SS';
        }
        return moment.utc(duration.asMilliseconds()).format(format);
    }
}